var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1128 7.8896H9.08V9.4264H3V3.2792H4.52V6.10691C7.18093 2.86812 11.5648 1.66397 15.4809 3.09622C19.3969 4.52847 22.0043 8.28957 22 12.5H20.48C20.4802 8.75778 18.0466 5.46086 14.4982 4.39629C10.9498 3.33172 7.13146 4.75294 5.1128 7.8896ZM18.8872 17.1104H14.92V15.5736H21V21.7208H19.48V18.8931C16.8191 22.1319 12.4352 23.336 8.51915 21.9038C4.60309 20.4715 1.99572 16.7104 2.00001 12.5H3.52C3.51977 16.2422 5.9534 19.5391 9.50179 20.6037C13.0502 21.6683 16.8685 20.2471 18.8872 17.1104Z",
    fill: "#E20074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.ec80bd57ca4bd59eeb78277104bb0d13.svg";
export { ForwardRef as ReactComponent };